import {
  OPEN_OVERVIEW_MODAL,
  CLOSE_OVERVIEW_MODAL,
  SET_ACTIVE_EDITOR,
  CLOSE_EDITOR,
  OPEN_NESTED_OVERVIEW_MODAL,
  CLOSE_NESTED_OVERVIEW_MODAL,
} from '../actions/types';

const INITIALSTATE = {
  activeEditor: null,
  isModalOpen: false,
  component: null,
  // isModalOpen: true,
  // component: "PreferencesEditor",
  // component: "TrekNameAndDateEditor",
  nestedModal: null,
  // props: {
  //   renderedBy: "use as template button"
  // }
};

export default (state = INITIALSTATE, action) => {
  const { component, props } = action;
  switch (action.type) {
    case OPEN_OVERVIEW_MODAL:
      return { ...state, isModalOpen: true, component, props };
    case OPEN_NESTED_OVERVIEW_MODAL:
      return {
        ...state,
        nestedModal: component,
      };
    case CLOSE_NESTED_OVERVIEW_MODAL:
      return {
        ...state,
        nestedModal: null,
      };
    case CLOSE_OVERVIEW_MODAL:
      return {
        ...state,
        component: null,
        isModalOpen: false,
        nestedModal: null,
      };
    case SET_ACTIVE_EDITOR:
      return { ...state, activeEditor: component };
    case CLOSE_EDITOR:
      return { ...state, activeEditor: null };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/trekOverviewReducer.js